<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" @click="Done">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 10pt; text-alignment: left;">{{ getCompanySetting('CompanyAddress').toString() }}</span></p>
                        <p v-if="getTaxSetting('TaxId')!=''" style="margin-top: 0;margin-bottom: 0;"><span style="font-size: 10pt; text-alignment: left;"><b>VAT Id Num: {{ getTaxSetting('TaxId') }}</b></span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Order Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordernum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.salesorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr v-if="initvalue.locationid">
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationcode'] : '' }}</span></td>
                          </tr>
                          <tr v-if="initvalue.channelid">
                            <td><span style="font-size: 11pt; font-weight: bold">Channel</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  saleschannels.length>0 ? saleschannels.find(channel=>channel._id == initvalue.channelid)['channelcode'] : '' }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                  <table style="width: 100%">
                  <tr>
                      <td><div align="center"><h2 class="ma-0"><b>{{initvalue.salesordertype}}</b></h2></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div v-if="initvalue.salesordertype!='Daily Sales'">
                          <span style="font-size: 11pt; font-weight: bold">Customer</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordername }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;" v-if="initvalue.salesorderaddress" v-html="initvalue.salesorderaddress.replaceAll('\n', '<br>')"></p>
                          <p style="margin-top: 0;margin-bottom: 0;">
                            <span v-if="initvalue.townshipid">{{ townships.length>0 ? townships.find(township=>township._id == initvalue.townshipid)['townshipname'] : '' }}</span>
                            <span v-if="initvalue.regionid">{{ regions.length>0 ? regions.find(region=>region._id == initvalue.regionid)['regionname'] : '' }}</span> 
                          </p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesorderphone }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordermobile }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Order Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ initvalue.salesordertype }}</span></td>
                          </tr>
                          <tr v-if="initvalue.customertype!=''">
                            <td><span style="font-size: 11pt; font-weight: bold">Customer Type</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.customertype }}</span></td>
                          </tr>
                          <tr v-if="initvalue.userid">
                            <td><span style="font-size: 11pt; font-weight: bold">Sales Rep</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{  users.length>0 ? users.find(user=>user._id == initvalue.userid)['username'] : '' }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="7%">&nbsp;</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="10%">Qty</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="10%">Unit</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="10%">Price</th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid; margin-bottom: 15px;" width="10%">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <p style="margin: 0;">{{ trans.itemname }}</p>
                            <p v-if="trans.itemdesc!=''" style="margin: 0;">{{ trans.itemdesc }}</p>
                          </td>
                          <td style="vertical-align: top;">{{ trans.itemfoc }}</td>
                          <td style="vertical-align: top;">{{ trans.itemquantity!==null ? trans.itemquantity.toFixed(0) : '' }}</td>
                          <td style="vertical-align: top;">{{ trans.unit }}</td>
                          <td style="vertical-align: top;">{{ trans.itemprice!==null ? trans.itemprice.toFixed(2) : '' }}</td>
                          <td style="vertical-align:top; text-align: right">{{ trans.itemamount!=null ? trans.itemamount.toFixed(2) : 0 }}</td>
                        </tr>
                        <tr><td colspan="7" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="2" style="vertical-align: top;">
                            <table width="100%">
                              <tr>
                                <td style="padding-bottom: 10px;"><div style="white-space: pre-wrap; word-wrap: break-word; " v-html="initvalue.salesordernote"></div></td>
                              </tr>
                              <tr>
                                <td v-if="data_paymethod.paymethodtype=='Qr Code'" colspan="5">
                                  <p style="padding-bottom: 1px;"><strong>{{ data_paymethod.paymethodcode }}</strong></p>
                                  <div>
                                    <img :src="data_paymethod.qrcodeimage" contain width="175">
                                  </div>
                                  <p style="padding-top: 2px;"><strong>{{ data_paymethod.paymethodinfo }}</strong></p>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td colspan="5" style="vertical-align: top; width: 47%;">
                            <table width="100%" >
                              <tr>
                                <td><span style="font-size: 11pt; font-weight: bold">Subtotal: </span></td>
                                <td v-if="initvalue.isDualCurrency==true" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordersubtotal).toFixed(0) }} </span><span style="font-size: 9pt;">{{ getCurrencySetting('SecondaryCurrency') }}</span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordersubtotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ getCurrencySetting('PrimaryCurrency') }}</span></td>
                              </tr>
                              <tr>
                                <td><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                                <td v-if="initvalue.isDualCurrency==true" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertotal).toFixed(0) }} </span><span style="font-size: 9pt;">{{ getCurrencySetting('SecondaryCurrency') }}</span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ getCurrencySetting('PrimaryCurrency') }}</span></td>
                              </tr>
                              <tr v-if="initvalue.isDualCurrency==true">
                                <td><span style="font-size: 11pt; font-weight: bold">Rate: </span></td>
                                <td v-if="initvalue.isDualCurrency==true" style="text-align: right"><span style="font-size: 11pt;">{{'1'}} </span><span style="font-size: 9pt;">{{ getCurrencySetting('PrimaryCurrency') }}&nbsp;&nbsp;&nbsp;&nbsp;=</span></td>
                                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.currencyRate.toFixed(0) }} </span><span style="font-size: 9pt;">{{ getCurrencySetting('SecondaryCurrency') }}</span></td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../util/tools';

    export default {
        name: 'PrintPage',
        data(){
          return {
            paymethod: null,
            qrsize: 100,
            initvalue: {},
            logo: null,
            isTrade: false,
            companysettings: null,
            currencysettings: null,
            taxsettings: null,
            signature: null,
          };
        },
        computed: {
          ...mapState('Location', ['locations']),
          ...mapState('SalesChannel', ['saleschannels']),
          ...mapState('Region', ['regions']),
          ...mapState('PayMethod', ['paymethods']),
          ...mapState('SystemSetting', ['settings']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
          data_paymethod(){
            if(this.paymethods==null || this.paymethods.lenght==0) return null;
            let paymethod = this.paymethods.find(i=>i._id == this.initvalue.paymethodid);
            if(paymethod!=null) return paymethod;
            return null;
          }
        },
        methods: {
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
          ...mapActions('PayMethod', ['getPayMethodsRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('SystemSetting', ['getSystemSettingsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          Done() {
            if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
            else this.$router.replace({ name: 'Dashboard' });
          },
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            
            setTimeout(function() {
              mywindow.print();
            }, 1000);
            return;
          },
          convertCurrency(amount){
            let rate = parseFloat(this.initvalue.currencyRate);
            console.log("rate", rate);
            if(rate==null) rate = 0;
            return amount * rate;
          },
          getCompanySetting(name){
            if(!this.companysettings) return '';
            let result = this.companysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getCurrencySetting(name){
            if(!this.currencysettings) return '';
            let result = this.currencysettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
          getTaxSetting(name){
            if(!this.taxsettings) return '';
            let result = this.taxsettings.settinglists.find(list=>list.settingname==name);
            if(result==null) return null;
            let value = result.settingvalue;
            value = value=='true' ? true : value;
            value = value=='false' ? false : value;
            value = value==null ? false : value;
            return value;
          },
        },

        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);
          this.signature = await require('@/assets/signature-director.png');
          console.log(this.initvalue);

          if(!this.initvalue._id) this.$router.push({ name: 'SalesOrderList' });
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.paymethods.length==0) await this.getPayMethodsRequest();
          if(this.settings.length==0) await this.getSystemSettingsRequest();
          if(this.townships.length==0) await this.getTownshipsRequest();
          if(this.users.length==0) await this.getUsersRequest();
          this.paymethod = this.paymethods.find(method=>method._id==this.initvalue.paymethodid);

          

          this.taxsettings = this.settings.find(setting=>setting.settingcode=='TaxSettings');
          this.companysettings = this.settings.find(setting=>setting.settingcode=='CompanySettings'); 
          this.currencysettings = this.settings.find(setting=>setting.settingcode=='CurrencySettings');  
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
